module.exports = __webpack_public_path__ + "static/media/akadam.c6d0a5af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quotes/akadam.jpg
// module id = 623
// module chunks = 0